import smoothscroll from 'smoothscroll-polyfill';
// import IntersectionObserver from './_main/IntersectionObserver';

import { isIE } from './utility';
import { CFG } from './config';
import Hamburger from './_main/Hamburger';
import Accordion from './_main/Accordion';
// import Menu from './_main/Menu';
// import AnchorScroll from './_main/AnchorScroll';
// import HeightSet from './_main/HeightSet';
import ScrollManager from './_main/ScrollManager';
// import Pagetop from './_main/Pagetop';
// import Validation from './_main/Validation';

import FeaturedSlides from './_main/FeaturedSlides';
import FollowingCtaController from './_main/FollowingCtaController';

// home
import NewsSlides from './_home/NewsSlides';
import PickupSlides from './_home/PickupSlides';
import FilteringCategories from './_home/FilteringCategories';

// archives
import ScrollLoading from './_archives/ScrollLoading';

// single
import RelatedSlides from './_single/RelatedSlides';

// download
import FilteringDownload from './_download/FilteringDownload';



{
    smoothscroll.polyfill();

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        })
    }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    // setTimeout(e=>{
    //     document.body.dataset.is = 'loaded';
    // }, 300);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    // const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    // if ( domAnchorScroll ) {
    //     domAnchorScroll.forEach(el => {
    //         new AnchorScroll(el);
    //     });
    // }

    // const domCassette = document.querySelectorAll('[data-js="io"]');
    // if ( domCassette ) {
    //     new IntersectionObserver(domCassette);
    // }    
}



/**
 * common
 */
{
    const domFeaturedSlides = document.querySelector('[data-swpr="featured"]');
    if( domFeaturedSlides ) new FeaturedSlides(domFeaturedSlides);

    const domFollowingCtaController = document.querySelector('[data-js="following-cta"]');
    if( domFollowingCtaController ) new FollowingCtaController(domFollowingCtaController);
}



/**
 * home
 */
{
    const domNewsSlides = document.querySelector('[data-swpr="news"]');
    if( domNewsSlides ) new NewsSlides(domNewsSlides);
    
    const domPickup = document.querySelector('[data-swpr="pickup"]');
    if( domPickup ) new PickupSlides(domPickup);

    // フィルタリング機能
    const domFilteringCategories = document.querySelector('[data-js="conditions-categories"]');
    if ( domFilteringCategories ) new FilteringCategories(domFilteringCategories);
}



/**
 * archives
 */
{
    const domScrollLoading = document.querySelector('[data-js="conditions-post"]');
    if( domScrollLoading ) new ScrollLoading(domScrollLoading);
}



/**
 * single
 */
{
    const domRelated = document.querySelector('[data-swpr="related"]');
    if( domRelated ) new RelatedSlides(domRelated);
}



/**
 * download
 */
 {
    // フィルタリング機能
    const domFilteringDownload = document.querySelector('[data-js="conditions-download"]');
    if ( domFilteringDownload ) new FilteringDownload(domFilteringDownload);
}
